import { useCallback } from 'react';

import { logger } from '@zep/core-logger';

import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { useUser } from '@/lib/auth';
import { QuizWorksheetExportModal } from '@/views/QuizDetail/QuizWorksheet/QuizWorksheetExportModal';

import { getCategoryName } from '../../../utils/getCategoryName';

interface UseExportWorksheetHandlerParams {
  quizData: QuizSetDetailsRes;
}

/**
 * useExportWorksheetHandler - 워크시트 내보내기 핸들러
 *
 * @description
 * 플랜과 무관하게 QuizWorksheetExportModal을 열어 워크시트 미리보기를 제공합니다.
 * 비PRO 유저의 경우 모달 내부에서 가림막 UI와 업셀링 CTA로 분기됩니다.
 * 비PRO 유저가 워터마크를 DOM에서 제거함으로써 미리보기하는건 전혀 보안상 문제가 되지 않음!
 * 미리보기는 전혀 보안적으로 상관없음. pdf로 다운로드를 못하게 막아야하는게 중요한건데, 그것은 지금 비PRO 유저들에게 잘 막혀있음.
 */
export const useExportWorksheetHandler = ({
  quizData,
}: UseExportWorksheetHandlerParams) => {
  const { user } = useUser();

  return useCallback(() => {
    // planType 은 logger.setUserContext 가 모든 스팬에 싣는 global prop 이라
    // 여기서 다시 넣을 필요가 없다(같은 user.planType 값이었다).
    logger.track('quiz_worksheet_button_click');

    const { categoryTreeData, title, quizList, entryMapHashId, enterCode } =
      quizData;
    void QuizWorksheetExportModal.open({
      category: getCategoryName(categoryTreeData),
      defaultTitle: title,
      defaultTeacherName: user?.username ?? '',
      quizList,
      entryMapHashId,
      enterCode,
    });
  }, [quizData, user]);
};
